import React from "react";
import PropTypes from "prop-types";
import { useHistory, Link as PRLink } from "react-router-dom";
import styled from "styled-components";
import Div from "@components/Div";
import Icon from "@components/Icon";
import { BodyText } from "@components/Text";
import { ROUTES } from "@utils/constant";
import { redirectToBSSfo } from "@utils/utils";

const Link = styled(PRLink)`
  text-decoration: none;
`;

export const MenuItem = styled(Div)`
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  background: ${({ isActive }) =>
    isActive ? "var(--primary-hover)" : "var(--primary)"};
  border-left: ${({ isActive }) =>
    isActive ? "4px solid var(--text)" : "4px solid var(--transparent)"};
  padding: 0 var(--regular-spacing);
  &:hover {
    border-left: 4px solid var(--text);
    background: var(--primary-hover);
  }
`;

const MenuContent = ({ navItems = [] }) => {
  const history = useHistory();

  const isActive = (route) => {
    const { location = {} } = history || {};
    const { pathname = "" } = location || {};
    return pathname.search(route) >= 0 ? true : false;
  };

  const handleLogout = () => {
    localStorage.clear();
    redirectToBSSfo();
  };

  const handleExternalPageRedirection = (url) => () => {
    window.open(url);
  };

  const menuItem = (item) => {
    return (
      <MenuItem
        px="var(--regular-spacing)"
        mb="var(--regular-spacing)"
        isActive={isActive(item.redirectTo)}
      >
        <Icon
          name={item.icon}
          pr="var(--fs-mini)"
          fontSize="var(--fs-h5)"
          color="var(--text)"
        />
        <BodyText
          fontWeight={
            isActive(item.redirectTo)
              ? "var(--semibold-weight) !important"
              : "var(--normal-weight) !important"
          }
        >
          {item.label}
        </BodyText>
      </MenuItem>
    );
  };

  const mainContent = (items = []) =>
    items.map((item) => {
      const { label = "" } = item;
      if (item && item.isExternalPage) {
        return (
          <Link
            width={1}
            key={label}
            onClick={handleExternalPageRedirection(item.redirectTo)}
          >
            {menuItem(item)}
          </Link>
        );
      } else {
        return (
          <Link
            width={1}
            key={label}
            to={item.redirectTo !== ROUTES.LOGIN.URL ? item.redirectTo : null}
            onClick={item.redirectTo === ROUTES.LOGIN.URL ? handleLogout : ""}
          >
            {menuItem(item)}
          </Link>
        );
      }
    });

  return <Div width="inherit">{mainContent(navItems)}</Div>;
};

MenuContent.propTypes = {
  navItems: PropTypes.array,
};

export default MenuContent;
